import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import Container from 'components/Container';

import {
  Wrapper,
  BreadcrumbsList,
  BreadcrumbsItem
} from './Breadcrumbs.styles';

export interface BreadcrumbsProps {
  className?: string;
  isSpecialDesign?: boolean;
}

const buildBreadcrumbs = (paths: string[], startIndex: number) => {
  const breadcrumbs = [];

  breadcrumbs.push({ link: '/', label: 'home' });

  let currentPath = '';

  for (let i = 1; i <= startIndex; i++) {
    currentPath += `/${paths[i]}`;
    breadcrumbs.push({
      link: currentPath,
      label: paths[i].replaceAll('-', ' '),
    });
  }

  return breadcrumbs;
};

const Breadcrumbs = ({ isSpecialDesign = false, className = '' }: BreadcrumbsProps) => {
  const { pathname } = useLocation();
  const paths = pathname.split('/');

  const breadcrumbs = buildBreadcrumbs(paths, paths.length - 1);

  const showBreadcrumbs = breadcrumbs.length > 2;

  return showBreadcrumbs ? (
    <Wrapper className={className} isSpecialDesign={isSpecialDesign}>
      <Container>
        <BreadcrumbsList>
          {
            breadcrumbs.map((path, index) => (
              <BreadcrumbsItem key={path.link}>
                {index === breadcrumbs.length - 1 ? path.label : (
                  <Link to={path.link}>{path.label}</Link>
                )}
              </BreadcrumbsItem>
            ))
          }
        </BreadcrumbsList>
      </Container>
    </Wrapper>
  ) : null;
};

export default Breadcrumbs;
